import React from "react";
import { useToast } from "../contexts/ToastContext";
import ToastComponent from "./Toast";
import { AnimatePresence } from "framer-motion";

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  return (
    <div
      className="fixed right-4 z-[9999] w-full max-w-sm space-y-2"
      style={{
        top: `max(calc(env(safe-area-inset-top, 0px) + 1rem), calc(44px + 1rem))`,
      }}
      aria-live="polite"
    >
      <AnimatePresence>
        {toasts.map((toast) => (
          <ToastComponent key={toast.id} toast={toast} onRemove={removeToast} />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ToastContainer;
